import Util from "@/utility/Utility";
import { DirectiveBinding } from "vue/types/options";

export const datetimetext = (el: HTMLElement, binding: DirectiveBinding) => {
  let value = binding.value.value || "";
  const format = binding.value.format;
  const defaultvalue = binding.value.defaultvalue || "";
  if (Util.isArray(value)) {
    value = value[0];
  }
  if (Util.isString(value)) {
    value = Util.parseYYYYMMDD(value);
  }
  if (Util.isDate(value)) {
    value = Util.formatDate(value, format);
  }

  if (value !== "") {
    el.innerHTML = value;
  } else {
    el.innerHTML = defaultvalue;
  }
};
